import { createRoot } from 'react-dom/client';
import { ReactNotifications } from 'react-notifications-component';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as Sentry from "@sentry/react";
import store from './store/index';
import Layout from './layout/Layout';
import axiosInterceptor from './layout/components/helpers/axiosInterceptor';
import i18n from './translations';
import 'react-datepicker/dist/react-datepicker.css';
import "react-notifications-component/dist/theme.css";
import "remixicon/fonts/remixicon.css";
import './App.css';
import { isExpectedAuthAxiosError } from './minions/error';

Sentry.init({
  dsn: 'https://e3afb2a90a56ca1785dd0b44d91757e6@o1355535.ingest.us.sentry.io/4511013396414464',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: process.env.NODE_ENV === 'development' ? 'development' : 'production',
  beforeSend(event, hint) {
    if (isExpectedAuthAxiosError(hint.originalException)) {
      return null;
    }
    return event;
  },
});
axiosInterceptor();


createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <ReactNotifications />
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  </Provider>
);
